import { render, staticRenderFns } from "./InstallUpdateModal.vue?vue&type=template&id=06e444ae&scoped=true"
import script from "./InstallUpdateModal.vue?vue&type=script&lang=js"
export * from "./InstallUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./InstallUpdateModal.vue?vue&type=style&index=0&id=06e444ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e444ae",
  null
  
)

export default component.exports